import { useQuery } from "@tanstack/react-query";

import { adminApi, OptionType } from "@/api/admin";

import { QUERY_KEYS } from "../constants";

export const useGetOptionsQuery = (types: OptionType | OptionType[]) => {
  return useQuery({
    queryKey: [QUERY_KEYS.adminOptions, types],
    queryFn: () => adminApi.getOptions(types),
    enabled: !!types && (Array.isArray(types) ? types.length > 0 : true),
  });
};

export const useGetCityByCountrysQuery = (countryCode: string) => {
  return useQuery({
    queryKey: [QUERY_KEYS.countryCity, countryCode],
    queryFn: () => adminApi.getCityByCountry(countryCode),
    enabled: !!countryCode,
  });
};

export const useGetAdminRolesAssignmentQuery = (enabled: boolean = true) => {
  return useQuery({
    queryKey: [QUERY_KEYS.adminAssignment],
    queryFn: () => adminApi.getAdminRolesAssignments(),
    enabled,
  });
};
